import { Job } from 'generated/apolloComponents'
import useTranslation from 'next-translate/useTranslation'
import { getContractTypes } from '@/helpers/utils'
import DropdownString from '../DropdownString'
import style from './JobListItem.module.scss'
import { locationList } from '@/helpers/jobUtils'

interface IProps {
  job: Job
}

const JobListItemDetails = ({ job }: IProps) => {
  const { t } = useTranslation('common')

  const locations = locationList(job)

  return (
    <div className={` ${style.item__details}`}>
      {locations.length > 0 && (
        <DropdownString icon list={locations} limit={2} />
      )}
      <div className='items-start hidden md:flex'>
        <svg className='w-6 h-6 mr-1' fill='currentColor'>
          <use href='#heroicon-document-text-icon' />
        </svg>
        <span>
          {job.employmentType === 'full_time'
            ? getContractTypes(job)
                .map((item) => t(`${item}`))
                .join('/')
            : t(`common:${job.employmentType}`)}
        </span>
      </div>
      {job.experienceLevel && (
        <div className='items-start hidden md:flex'>
          <svg className='w-6 h-6 mr-1' fill='currentColor'>
            <use href='#heroicon-square-3-stack-3d-icon' />
          </svg>
          <span>{t(`common:${job.experienceLevel}`)}</span>
        </div>
      )}
    </div>
  )
}

export default JobListItemDetails
